import { FC, PropsWithChildren, useState } from 'react';
import {
    NavigationDrawerContainer,
    NavigationDrawerStyledProps,
    Handle
} from './Styled';
import { useSidenavState } from 'providers';
import {
    SIDEBAR_MAX_WIDTH,
    SIDEBAR_MIN_WIDTH,
    SIDEBAR_NARROW_BREAKPOINT
} from '../../config';

export interface NavState {
    isNarrow: boolean;
    width: number;
}

export const NavigationDrawer: FC<
    PropsWithChildren<NavigationDrawerStyledProps>
> = ({ children }) => {
    const [rafId, setRafId] = useState(null);
    const { width, setState } = useSidenavState();

    const onMousemove = (e: MouseEvent) => {
        e.preventDefault();
        setRafId(requestAnimationFrame(() => resize(e)));
    };

    const onMouseDown = () => {
        document.addEventListener('mousemove', onMousemove);
        document.addEventListener(
            'mouseup',
            () => {
                if (rafId != null) cancelAnimationFrame(rafId);
                document.removeEventListener('mousemove', onMousemove);
            },
            { once: true }
        );
    };

    const onDoubleClick = () => {
        if (width < SIDEBAR_MAX_WIDTH / 2) {
            applyWidth(SIDEBAR_MAX_WIDTH);

            return;
        }

        applyWidth(SIDEBAR_MIN_WIDTH);
    };

    const resize = (e: MouseEvent) => {
        let value = e.pageX;

        if (value < SIDEBAR_MIN_WIDTH) {
            value = SIDEBAR_MIN_WIDTH;
        }

        if (value > SIDEBAR_MAX_WIDTH) {
            value = SIDEBAR_MAX_WIDTH;
        }

        applyWidth(value);
    };

    const applyWidth = (newWidth: number) => {
        setState((prevState) => ({
            ...prevState,
            isNarrow: newWidth < SIDEBAR_NARROW_BREAKPOINT,
            width: newWidth
        }));
        localStorage.setItem('sideBarWidth', newWidth.toString());
    };

    return (
        <NavigationDrawerContainer width={width}>
            {children}
            <Handle onMouseDown={onMouseDown} onDoubleClick={onDoubleClick} />
        </NavigationDrawerContainer>
    );
};
